export default {
  language: {
    name: 'English',
  },
  footer: {
    about: '关于我们',
    view: 'Do network 概述',
    wiki: '技术wiki',
    legal: '法律协议',
    serve: '社区活动',
    privacy: '隐私协议',
    notices: '法律声明',
    partner: '合作伙伴',
    HBTC: 'HBTC',
    token: 'TokenInsight',
    block: '499Block',
    contact: '联系我们',
    email: '邮箱:snajw@163.com',
    join: '加入我们',
    feixiaohao: '非小号',

  },
};
